/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookRegistrationRequestModel } from '../../models/book-registration-request-model';
import { BookRegistrationResultModel } from '../../models/book-registration-result-model';

export interface BookPost$Params {
      body?: BookRegistrationRequestModel
}

export function bookPost(http: HttpClient, rootUrl: string, params?: BookPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<BookRegistrationResultModel>> {
  const rb = new RequestBuilder(rootUrl, bookPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<BookRegistrationResultModel>;
    })
  );
}

bookPost.PATH = '/Book';
